import { useSession } from "@clerk/clerk-react";
import { getUnexpiredToken } from "./utils";
import { useCallback } from "react";
import axios from "axios";

export const useUpdateProjectPreview = () => {
  const { session } = useSession();
  const updateProjectPreview = useCallback(
    async (projectId: string, imageData: Blob) => {
      if (!session) {
        return;
      }

      const formData = new FormData();
      formData.append("file", imageData);

      const supabaseJWT = await getUnexpiredToken(session);
      await axios.post(
        `${
          import.meta.env.VITE_BACKEND_BASE_URL
        }/projects/${projectId}/updatePreview`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${supabaseJWT}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );
    },
    [session],
  );
  return updateProjectPreview;
};
